import React from 'react'
import { IconChevronRight } from '@tabler/icons-react'
import Typography from '../atoms/Typography'
import { folderPathSegments } from '../../enviroment/utils/folderPathSegments'

interface FolderBreadcrumbsProps {
  path: string | null
  rootLabel: string
  rootIcon?: React.ReactNode
  variant: 'base-bold' | 'sm'
  onSelect: (path: string | null) => void
}

const FolderBreadcrumbs: React.FC<FolderBreadcrumbsProps> = ({ path, rootLabel, rootIcon, variant, onSelect }) => (
  <div className="flex flex-wrap items-center gap-1">
    <button
      type="button"
      onClick={() => onSelect(null)}
      className="flex items-center gap-1 rounded px-1 py-0.5 transition-colors hover:bg-gray-800"
    >
      {rootIcon}
      <Typography variant={variant} className="text-gray-50">
        {rootLabel}
      </Typography>
    </button>
    {path &&
      folderPathSegments(path).map((segment) => (
        <React.Fragment key={segment.path}>
          <IconChevronRight className="h-4 w-4 shrink-0 text-gray-500" />
          <button
            type="button"
            onClick={() => onSelect(segment.path)}
            className="rounded px-1 py-0.5 transition-colors hover:bg-gray-800"
          >
            <Typography variant={variant} className="text-gray-50">
              {segment.name}
            </Typography>
          </button>
        </React.Fragment>
      ))}
  </div>
)

export default FolderBreadcrumbs
